export { default } from './two-column.view';
